import React, { useState } from 'react';

import PropertyNoteCard from './property_note_card';
import PropertyNoteForm from './property_note_form';
import type { Note } from 'bundles/connect/types';

type Props = {
  note: Note,
  onRemove: (id: number) => void,
  onUpdate: (newNote: Note) => void
}
export default function NoteSection({ note, onUpdate, onRemove }: Props) {
  const [showNoteEditor, setShowNoteEditor] = useState(!note);

  const handleSaveNote = (newNote) => {
    onUpdate(newNote);

    setShowNoteEditor(false);
  };

  if (showNoteEditor) return (
    <PropertyNoteForm
      note={note}
      onClose={() => setShowNoteEditor(false)}
      onSave={handleSaveNote}
    />
  );

  return (
    <PropertyNoteCard note={note} onEdit={() => setShowNoteEditor(true)} onRemove={onRemove} />
  );
}
